// extracted by mini-css-extract-plugin
export var editButton = "_ol-0";